import styled from "styled-components";
import { device } from "../../config/sizes";

export const AuthorBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 2em 0;

  @media ${device.mobile} {
    flex-direction: column;
  }
`

export const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: calc(50% - 2em);
  margin: 0 2em 3em 0;

  @media ${device.mobile} {
    flex-direction: column;
    align-content: center;
    text-align: center;
    max-width: 100%;
    margin: 0 0 3em;
  }
`;

export const AuthorImageWrapper = styled.img`
  align-self: auto;
  height: 7em;
  width: 7em !important;
  border-radius: 50%;
  filter: grayscale(1);
  margin-right: 1em;

  @media ${device.mobile} {
    margin-right: 0;
    margin-bottom: 1em;
    align-self: center;
  }
`;

export const TextWrapper = styled.div`
  font-size: 0.85em;
  display: flex;
  flex-direction: column;

  @media ${device.mobile} {
    font-size: 1em;
  }
`;

export const SocialMediaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 1em;

  img {
    padding-right: 0.75em;
    opacity: 0.6;
    height: auto;
    width: auto;
  }

  @media ${device.mobile} {
    justify-content: center;
  }
`;
